<template>
    <div class="instruction-container">
        <div class="col-12 title-container">
            <h3 class="two-step-title">Two-step verification</h3>
            <div class="two-step-desc">{{CONSTANTS.TWO_STEP_DESC_TEXT}}</div>
        </div>
        <div class="authenticator-registration">
            <h1 class="mb-1">Microsoft Authenticator registration</h1>
            <div class="mb-3">{{CONSTANTS.AUTHENTICATOR_DESC_TEXT}}</div>
        </div>
        <ul>
            <li v-for="(step, index) in CONSTANTS.AUTHENTICATOR_STEPS" :key="index" class="registration-step py-4">
                <div class="numbered-label">{{index+1}}</div>
                <span @click="onLinkClick" v-html="step"></span>
            </li>
        </ul>
        <div class="row form-field-row register-button">
            <div class="col text-center text-sm-center text-lg-left">
                <a class="mixpanel-link btn flat-blue-btn reset-btn text-center" @click="onLinkClick" target="_blank" href="https://mysignins.microsoft.com/security-info">Register device</a>
            </div>
        </div>
    </div>
</template>
<script>
import MixpanelMixin from "@/mixins/MixpanelMixin";
export default {
    name: "TwoStepInstructions",
    mixins: [MixpanelMixin],
    methods: {
        onLinkClick(event) {
            if (event.target.classList.contains('mixpanel-link')) {
                this.trackEvent(`Two-step verification - My sign-ins link clicked`);
            }
        }
    }
}
</script>
<style scoped>
.instruction-container {
    padding: 60px 80px 60px 80px;
    font-size: 16px;
}
.register-button {
    margin-top: 20px;
    margin-bottom: 30px;
    max-width: 275px;
}
.register-button >>> span {
    width: 100%;
}
.two-step-desc {
    color: #000;
    font-size: 16px;
    white-space: pre-wrap;
    padding: 0 20px 15px 0;
}
.two-step-title {
    font-weight: bold;
    line-height: normal;
    font-size: 38px;
    color: #000;
    font-family: artifaktElementExtraBold;
    margin: 0;
}
.numbered-label {
    min-height: 25px; 
    min-width: 25px; 
    border: 1px solid black; 
    margin-right: 10px; 
    text-align: center; 
    border-radius: 3px;
    vertical-align: middle;
    font-family: artifaktElementExtraBold;
}
.authenticator-registration h1 {
    font-size: 20px;
    font-family: artifaktElementBold;
    padding-top: 20px;
}
.registration-step span {
    font-weight: 600;
}
.registration-step /deep/ b {
    font-family: artifaktElementBold;
}
.registration-step /deep/ a {
    color: #5F60FF !important;
    font-family: artifaktElementBold;
}
.registration-step /deep/ a:hover {
    color: #1F20BF !important;
    text-decoration: none !important;
}
.reset-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: artifaktElementBold;
}
.reset-btn:hover {
    color: #fff !important;
}
.requirement-content {
    font-weight: normal;
    font-family: artifaktElementRegular;
}
.sub-title {
    font-family: artifaktElementBold;
}
.title-container {
    padding: 0;
}
ul {
    padding: 0;
}
ul li {
    display: flex;
    align-items: center;
}
@media (max-width: 576px) {
    .instruction-container {
        font-size: 14px;
        padding: 10px 20px 10px 20px;
    }
    .two-step-desc {
        font-size: 14px;
    }
    .two-step-title {
        font-size: 26px;
    }
    .authenticator-registration h1 {
        font-size: 20px;
    }
}
</style>
